import { NotificacaoInterface } from '@/shared/models/notificacao/notificacao.interface';
import timeDifference from '@/shared/utils/time-difference';

const horaRegEx = new RegExp(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/);

export default {

  campo_obrigatorio: (v: any) => (v !== undefined && v !== null && v.length !== 0) || 'Campo obrigatório!',

  password: (v: any) => (v !== null && v.length >= 8 && v.length <= 256) || 'A senha deve possuir entre 8 e 256 caracteres!',

  email: (v: any) => /.+@.+\..+/.test(v) || 'E-mail não está no formato válido!',

  somente_numeros_positivos: (v: number) => (v > 0) || 'Coloque apenas números positivos!',

  somente_numeros_diferente_zero: (v: any) => (v !== 0) || 'Coloque um número diferente de zero!',

  somente_numeros_inteiros: (v: any) => /^[0-9]+$/.test(v) || 'Coloque apenas números!',

  latitude_longitude: (v: string) => /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/.test(v) || 'Insira coordenadas válidas',

  valida_somente_espacos: (v: any) => (v !== null && v !== undefined && (v.trim() !== '' && v.trim() !== '(')) || 'Informação inválida!',

  codigo_area: (v: any) => (v !== null && v.length === 2) || 'O código de área deve ter 2 números!',

  data: (v: any) => {
    const pattern = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
    return pattern.test(v) || 'Data inválida!';
  },

  caixa_alta_com_underline: (v: any) => {
    const pattern = /[A-Z]+(_[A-Z]+)*$/;
    return pattern.test(v) || 'Código inválido! Ex: CODIGO_EXEMPLO';
  },

  numero_positivo_com_duas_casas_decimais: (v: any) => {
    const pattern = /^\d+((\.\d{1,2}){0,1})$/;
    return pattern.test(v) || 'Fator inválido! Ex: 51.96';
  },

  validarDataNotificacao(body: NotificacaoInterface) {
    if (body.periodoNotificacao === 'NOTIFICACAO_DIARIA') {
      return (timeDifference.differenceInDays(body.inicioPeriodo, body.fimPeriodo) >= 1) || 'A data final deve ser depois de pelo menos 1 dia da data inicial.';
    }

    if (body.periodoNotificacao === 'NOTIFICACAO_SEMANAL') {
      return (timeDifference.differenceInWeeks(body.inicioPeriodo, body.fimPeriodo) >= 1) || 'A data final deve ser depois de pelo menos uma semana da data inicial.';
    }

    if (body.periodoNotificacao === 'NOTIFICACAO_MENSAL') {
      return (timeDifference.differenceInMonths(body.inicioPeriodo, body.fimPeriodo) >= 1) || 'A data final deve ser depois de pelo menos 30 dias da data inicial.';
    }
    return true;
  },
};
